exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 365px) {\n.billable-after[data-v-22d365ec] {\n    white-space: nowrap;\n}\n}\n@media (max-width: 240px) {\n.billable-after[data-v-22d365ec] {\n    white-space: normal;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22d365ec","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/multiplePhonePlan/cartTotalInfo/CheckoutSummary.vue
// module id = 1072
// module chunks = 0